import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("bt_admin_token");
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
      localStorage.removeItem("bt_admin_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const apiError = (err, fallback) =>
  err?.response?.data?.detail || fallback;
